import * as Types from '../../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
export type WorkOrdersTableColumnFragment = { __typename?: 'JobForTable', jobMetadata: { __typename?: 'JobForTableMetadata', id: string, workOrderId: string, jobNumber: number, createdAt: any, deletedAt?: any | null, timeKeysReceived?: any | null, timeCompleted?: any | null, timePickedUp?: any | null, mechanicShopStatus?: Types.JobMechanicShopStatus | null, totalPaid?: number | null, carOdometer?: number | null }, invoice?: { __typename?: 'InvoiceForTable', remainingWithCreditCardFeesRecoup: number, approvedOn?: any | null } | null, appointment?: { __typename?: 'AppointmentForTable', id: string, expectedDropoffTime?: any | null } | null, car?: { __typename?: 'CarForTable', createdAt: any, id: string, make?: string | null, model?: string | null, year?: number | null, colour?: string | null, vin?: string | null, licensePlate?: string | null } | null, customer?: { __typename?: 'CustomerForTable', createdAt: any, id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, secondaryPhoneNumber?: string | null, companyName?: string | null } | null };

export const WorkOrdersTableColumnFragmentDoc = gql`
    fragment WorkOrdersTableColumn on JobForTable {
  jobMetadata {
    id
    workOrderId
    jobNumber
    createdAt
    deletedAt
    timeKeysReceived
    timeCompleted
    timePickedUp
    mechanicShopStatus
    totalPaid
    carOdometer
  }
  invoice {
    remainingWithCreditCardFeesRecoup
    approvedOn
  }
  appointment {
    id
    expectedDropoffTime
  }
  car {
    createdAt
    id
    make
    model
    year
    colour
    vin
    licensePlate
  }
  customer {
    createdAt
    id
    firstName
    lastName
    email
    phoneNumber
    secondaryPhoneNumber
    companyName
  }
}
    `;